module.exports = __webpack_public_path__ + "static/media/menu.6249efd6.svg";